import api from '@/libs/api'
import store from '@/store'

const projectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    requestStats: [],
    trafficStats: [],
    usedSpaceStats: [],
    objectsCountStats: [],
    loadingRequestStats: false,
    loadingTrafficStats: false,
    loadingUsedSpaceStats: false,
    loadingObjectsCountStats: false,
  },
  mutations: {
    LOADING_REQUESTS_STATS(state, value) {
      state.loadingRequestStats = value
    },
    LOADING_TRAFFIC_STATS(state, value) {
      state.loadingTrafficStats = value
    },
    LOADING_USED_SPACE_STATS(state, value) {
      state.loadingUsedSpaceStats = value
    },
    LOADING_OBJECTS_COUNT_STATS(state, value) {
      state.loadingObjectsCountStats = value
    },
    SET_REQUESTS(state, value) {
      state.requestStats = value
    },
    SET_TRAFFIC(state, value) {
      state.trafficStats = value
    },
    SET_USED_SPACE(state, value) {
      state.usedSpaceStats = value
    },
    SET_OBJECTS_COUNT(state, value) {
      state.objectsCountStats = value
    },
    CLEAR_ANALYTICS(state) {
      state.requestStats = []
      state.trafficStats = []
      state.usedSpaceStats = []
      state.objectsCountStats = []
    },
  },
  actions: {
    fetchRequestStats({ commit }, query) {
      commit('LOADING_REQUESTS_STATS', true)
      return new Promise((resolve, reject) => {
        api('storage')
          .post(`/v2/projects/${projectId()}/account/${query.accountId}/buckets/requests`, query.body)
          .then(response => {
            commit('SET_REQUESTS', response.data.result)
            resolve(response)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('LOADING_REQUESTS_STATS', false)
          })
      })
    },
    fetchTrafficStats({ commit }, query) {
      commit('LOADING_TRAFFIC_STATS', true)
      return new Promise((resolve, reject) => {
        api('storage')
          .post(`/v2/projects/${projectId()}/account/${query.accountId}/buckets/traffic`, query.body)
          .then(response => {
            commit('SET_TRAFFIC', response.data.result)
            resolve(response)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('LOADING_TRAFFIC_STATS', false)
          })
      })
    },
    fetchUsedSpaceStats({ commit }, query) {
      commit('LOADING_USED_SPACE_STATS', true)
      return new Promise((resolve, reject) => {
        api('storage')
          .post(`/v2/projects/${projectId()}/account/${query.accountId}/buckets/used-space`, query.body)
          .then(response => {
            commit('SET_USED_SPACE', response.data.result)
            resolve(response)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('LOADING_USED_SPACE_STATS', false)
          })
      })
    },
    fetchObjectsCount({ commit }, query) {
      commit('LOADING_OBJECTS_COUNT_STATS', true)
      return new Promise((resolve, reject) => {
        api('storage')
          .post(`/v2/projects/${projectId()}/account/${query.accountId}/buckets/object-count`, query.body)
          .then(response => {
            commit('SET_OBJECTS_COUNT', response.data.result)
            resolve(response)
          })
          .catch(err => {
            this.trafficSum = []
            reject(err)
          })
          .finally(() => {
            commit('LOADING_OBJECTS_COUNT_STATS', false)
          })
      })
    },
  },
}
